var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftsidecontacticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-157 -723)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 20,
    height: 20,
    transform: "translate(157 723)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "leftsidecontacticon",
    transform: "translate(154.954 721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M18.954,21H5.046a2,2,0,0,1-2-2V8a2,2,0,0,1,2-2H18.954a2,2,0,0,1,2,2V19A2,2,0,0,1,18.954,21Z",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M12,9a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,12,9Z",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M16.5,18a2.38,2.38,0,0,0-2.208-1.5H9.708A2.38,2.38,0,0,0,7.5,18",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M4.782,6V5a2,2,0,0,1,2-2H17.217a2,2,0,0,1,2,2V6",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftsidecontacticon);
export default __webpack_public_path__ + "static/media/leftsidecontacticon.a49f3c247c893c92c19b1fc629396350.svg";
export { ForwardRef as ReactComponent };